module.exports = __webpack_public_path__ + "img/chrome.4c2482af.png";